// src/context/AdminContext.jsx
import React, { createContext, useContext } from 'react';
import { useAuth } from "./AuthContext";
import { isAdminUser } from "../constants/roles";

const AdminContext = createContext();

// App.jsx'in aradığı eksik parça burası:
export function AdminProvider({ children }) {
  const { user } = useAuth();
  const adminResolved = isAdminUser(user);

  return (
    <AdminContext.Provider value={{ isAdmin: adminResolved }}>
      {children}
    </AdminContext.Provider>
  );
}

// Bileşenlerin kullandığı hook
export function useAdmin() {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
}
